import { FC, ReactNode } from 'react';

import { Switch, SwitchProps } from 'react-router-dom';

interface AppSwitchProps extends SwitchProps {
  children: ReactNode;
}

const AppSwitch: FC<AppSwitchProps> = ({ children, ...props }) => {
  return <Switch {...props} >{children}</Switch>
};

export default AppSwitch;
